module.exports = __webpack_public_path__ + "static/media/Sharetemplate.29d3d3db.svg";